import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHeaderFilters } from '@/features/header-filters';
import { useServiceRequestsFilters } from '../lib/use-service-requests-filters';
import { ServiceRequestsPage } from './service-requests-page';
import { ServiceRequestsFilterBar } from './service-requests-filter-bar';

export function ServiceRequestsWithFilters() {
  const { t } = useTranslation();
  const { setFilterConfig, setSearchConfig } = useHeaderFilters();

  const {
    urlState,
    searchQuery,
    activeFiltersCount,
    isFiltersDirty,
    hasDefaultFilters,
    handleFilterChange,
    handleSearchChange,
    handleReset,
    handleApplyFilters
  } = useServiceRequestsFilters();

  useEffect(() => {
    const config = {
      defaultValue: searchQuery,
      placeholder: t('common.search', 'Search among relevant properties'),
      onChange: handleSearchChange,
      enabled: true
    };
    setSearchConfig(config);
  }, [handleSearchChange, searchQuery, setSearchConfig, t]);

  useEffect(() => {
    const filterContent = <ServiceRequestsFilterBar filters={urlState} onFilterChange={handleFilterChange} />;

    setFilterConfig({
      id: 'service-requests-filters',
      title: t('serviceRequests.filters.title', 'Filter Service Requests'),
      content: filterContent,
      activeCount: activeFiltersCount,
      onReset: handleReset,
      onApply: handleApplyFilters,
      isApplyDisabled: !isFiltersDirty,
      isResetDisabled: hasDefaultFilters
    });
  }, [
    activeFiltersCount,
    handleFilterChange,
    handleReset,
    handleApplyFilters,
    isFiltersDirty,
    hasDefaultFilters,
    setFilterConfig,
    t,
    urlState
  ]);

  return <ServiceRequestsPage />;
}
